













import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class Card extends Vue {
  @Prop({ default: '' }) size;
  @Prop({ default: false }) closable;
  @Prop({ default: '/v2/login' }) navigateToAfterClose;
}
